import React from 'react';
import { isDarkTheme } from '../../utils';
import { WHITE } from '../../constants';

const getStyles = () => {
  const isDark = isDarkTheme();

  const progressBarWrapper: React.CSSProperties = {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
  };

  const progressBarContainer: React.CSSProperties = {
    width: '100%',
    backgroundColor: isDark ? '#3a3a3a' : '#e0e0e0',
    borderRadius: '25px',
    overflow: 'hidden',
    position: 'relative',
  };

  const progressBar: React.CSSProperties = {
    height: '20px',
    borderRadius: '25px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    transition: 'width 0.3s ease',
  };

  const progressText: React.CSSProperties = {
    color: 'white',
    fontWeight: 'bold',
    position: 'absolute',
    left: '50%',
    top: '50%',
    transform: 'translate(-50%, -50%)',
    fontSize: window.innerWidth <= 500 ? '9px' : '12px',
    textShadow: '1px 1px 2px rgba(0, 0, 0, 0.5)',
    whiteSpace: 'nowrap',
    padding: '0 4px',
    zIndex: 1,
  };

  const progressLabelBelow: React.CSSProperties = {
    marginTop: '4px',
    fontSize: window.innerWidth <= 500 ? '10px' : '12px',
    color: isDark ? WHITE : '#444444',
    fontWeight: 500,
    textAlign: 'center',
    lineHeight: '1.3',
  };

  return {
    progressBarWrapper,
    progressBarContainer,
    progressBar,
    progressText,
    progressLabelBelow,
  };
};

export default getStyles;